// Vendor
import $ from 'jquery';
//import Helper from '../helpers/util';

// Element
let $el = $('.lightbox');
let $cta = $('.lightbox-video-link');

class Lightbox {
	constructor($el, $cta) {
		this.$el = $el;
		this.$outer = $el.find('.lightbox-outer');
		this.$container = $el.find('.lightbox-video-container');
		this.$close = $el.find('.lightbox-close');
		this.$video = $el.find('.lightbox-video');
		this.$cta = $cta;

		this.playerReady = false;

		//this.doLayout();
		this.checkYoutubeBlock();
		this.attachHanders();
	}

	doLayout() {
		let ratio = 1.777777778;

		let h = this.$outer.height();
		let w = this.$outer.width();

		let newW = -1;
		let newH = -1;

		let tmp = w / ratio;

		if (tmp > h) {
			newH = h;
			newW = h * ratio;
		} else {
			newH = w / ratio;
			newW = w;
		}

		this.$container.css({
			height: newH,
			width: newW
		});
	}

	checkYoutubeBlock() {
		let image = new Image();
		image.onerror = ()=>{
			// youtube is blocked
			this.$cta.each(function(){
				$(this).addClass('youtube-blocked');
			});
		};
		image.src = '//youtube.com/favicon.ico';
	}

	attachHanders() {
		// Helper.pubsub.subscribe('onWindowResize', () => {
		// 	this.doLayout();
		// });

		this.$close.on('click', () => {
			this.$el.removeClass('is-visible');
			if (this.player.getPlayerState() === 1) {
				this.player.pauseVideo();
			}
		});

		if (this.$cta.length) {
			this.$cta.on('click', (evt) => {
				const videoId = $(evt.target).attr('data-id');
				if ( !$(evt.target).hasClass('youtube-blocked') ) {
					this.$el.addClass('is-visible');
					if (this.playerReady) {
						this.player.loadVideoById(videoId);
					} else {
						this.initVideo(videoId);
					}
				}
			});
		}

	}

	initVideo(videoId) {
		let js = document.createElement('script');
		js.type = 'text/javascript';
		js.src = 'https://www.youtube.com/iframe_api';
		document.body.appendChild(js);

		window.onYouTubeIframeAPIReady = () => {
			this.playerReady = true;
			this.renderVideo(videoId);
		};
	}

	renderVideo(videoId) {
		this.player = new window.YT.Player(this.$video.get(0), {
			height: '100%',
			width: '100%',
			videoId: videoId,
			playerVars: {
				autoplay: 1,
				showinfo: 0,
				rel: 0
			}
		});
		window.videoPlayer = this.player;
	}
}

const _init = () => {
	if ($el.length) {
		new Lightbox($el, $cta);
	}
};

_init();
